import Joi from 'joi-full';

import { getSchema as getBarberLocationDataSchema } from '../../../formBarbers/barberForm/helpers';
import { LOCATIONS_ALL_ID } from '../constants';
import { syncValidateData } from '../../../../../common/validator';

const getSchema = () => {
  const barberLocationDataSchema = getBarberLocationDataSchema();
  return Joi.object({
    [LOCATIONS_ALL_ID]: barberLocationDataSchema,
  }).pattern(/.*/, barberLocationDataSchema);
};

// eslint-disable-next-line import/prefer-default-export
export const validate = values => syncValidateData(values, getSchema());
